import {
  FormControl,
  Grid,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
} from '@mui/material'
import React from 'react'

const AccessLocation = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Access Location</InputLabel>
      <Select
        value={moduleValues?.['Access Location'] ?? ''}
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Access Location']: e.target.value,
          }))
        }
        label="Access Location"
      >
        <ListSubheader>Intravenous</ListSubheader>
        <MenuItem value="Right Arm (ACF)">Right Arm (ACF)</MenuItem>
        <MenuItem value="Left Arm (ACF)">Left Arm (ACF)</MenuItem>
        <MenuItem value="Right Hand/Wrist">Right Hand/Wrist</MenuItem>
        <MenuItem value="Left Hand/Wrist">Left Hand/Wrist</MenuItem>
        <MenuItem value="Right Lower Leg/Foot">Right Lower Leg/Foot</MenuItem>
        <MenuItem value="Left Lower Leg/Foot">Left Lower Leg/Foot</MenuItem>
        <MenuItem value="Left Jugular">Left Jugular</MenuItem>
        <MenuItem value="Right Jugular">Right Jugular</MenuItem>
        <ListSubheader>Intraosseous</ListSubheader>

        <MenuItem value="Humeral Head (Right)">Humeral Head (Right)</MenuItem>
        <MenuItem value="Humeral Head (Left)">Humeral Head (Left)</MenuItem>
        <MenuItem value="Proximal Tibia (Right)">
          Proximal Tibia (Right)
        </MenuItem>
        <MenuItem value="Proximal Tibia (Left)">Proximal Tibia (Left)</MenuItem>
        <MenuItem value="Distal Femur (Left)">Distal Femur (Left)</MenuItem>
        <MenuItem value="Distal Femur (Right)">Distal Femur (Right)</MenuItem>
        <MenuItem value="Distal Tibia (Right)">Distal Tibia (Right)</MenuItem>
        <MenuItem value="Distal Tibia (Left)">Distal Tibia (Left)</MenuItem>
        <MenuItem value="Sternum">Sternum</MenuItem>
      </Select>
    </FormControl>
  </Grid>
)

export default AccessLocation
